import React, { memo } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import './AssembleiaItem.scss';
import { ChevronArrowRightIcon } from 'plataforma-fundacao-componentes';
const rootClassName = 'assembleia-item';

interface AssembleiaItemProps {
  nomeCooperativa: string;
  presencial?: {
    endereco: string;
    dataInicio: string;
    dataTermino: string;
  };
  dataInicio?: string;
  dataTermino?: string;
  modo?: number;
  onClick?: (evt: any) => void;
  language: {
    dataInicio: string;
    dataTermino: string;
    enderecoDigital: string;
    presencial: string;
  };
}

function AssembleiaItem(props: AssembleiaItemProps) {
  return (
    <div
      className={clsx([rootClassName, props.modo === 1 ? 'presencial' : ''])}
    >
      <div
        onClick={props.onClick}
        className={clsx([
          `${rootClassName}-first`,
          props.modo === 1 ? 'presencial' : '',
        ])}
      >
        <div className={`${rootClassName}-left`}>
          <div className={`${rootClassName}-coop`}>
            {props.nomeCooperativa}
            {props.modo === 1 ? ` - ${props.language.presencial}` : ''}
          </div>
          <div className={`${rootClassName}-endereco nunito`}>
            {props.modo === 1
              ? props.presencial?.endereco
              : props.language.enderecoDigital}
          </div>
        </div>
        <div className={`${rootClassName}-right`}>
          <div className={`${rootClassName}-col-data`}>
            <div className={`${rootClassName}-label-data`}>
              {props.language.dataInicio}
            </div>
            <div className={`${rootClassName}-value-data nunito`}>
              {props.dataInicio}
            </div>
          </div>
          <div className={`${rootClassName}-col-data`}>
            <div className={`${rootClassName}-label-data`}>
              {props.language.dataTermino}
            </div>
            <div className={`${rootClassName}-value-data nunito`}>
              {props.dataTermino}
            </div>
          </div>
          <div className={`${rootClassName}-icon`}>
            <ChevronArrowRightIcon />
          </div>
        </div>
      </div>
      {props.presencial && props.modo !== 1 && (
        <div className={`${rootClassName}-second`}>
          <div className={`${rootClassName}-left`}>
            <div className={`${rootClassName}-coop`}>
              {props.language.presencial}
            </div>
            <div className={`${rootClassName}-endereco nunito`}>
              {props.presencial.endereco}
            </div>
          </div>
          <div className={`${rootClassName}-right`}>
            <div className={`${rootClassName}-col-data`}>
              <div className={`${rootClassName}-label-data`}>
                {props.language.dataInicio}
              </div>
              <div className={`${rootClassName}-value-data nunito`}>
                {props.presencial.dataInicio}
              </div>
            </div>
            <div className={`${rootClassName}-col-data`}>
              <div className={`${rootClassName}-label-data`}>
                {props.language.dataTermino}
              </div>
              <div className={`${rootClassName}-value-data nunito`}>
                {props.presencial.dataTermino}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(AssembleiaItem);
